export const SIDE_MENU_OPEN = 'SIDE_MENU:OPEN';
export const SIDE_MENU_CLOSE = 'SIDE_MENU:CLOSE';
